import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { useFormContext, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import DollarPriceInput from '../../../../../../DollarPriceInput';
import EarningsDisplay from '../../../../../../EarningsDisplay';
const PriceField = ()=>{
    var _errors_price;
    const { t  } = useTranslation();
    const { control , errors  } = useFormContext();
    const errorMessage = (_errors_price = errors.price) === null || _errors_price === void 0 ? void 0 : _errors_price.message;
    const _useController = useController({
        name: 'price',
        control
    }), { field: { ref  }  } = _useController, fieldProps = _object_without_properties(_useController.field, [
        "ref"
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DollarPriceInput, _extends({}, fieldProps, {
        label: t('mediapopup.gallections.a11y.priceInputLabel'),
        isLabelHidden: true,
        errorMessage: errorMessage,
        refInput: ref
    })), /*#__PURE__*/ React.createElement(EarningsDisplay, {
        dollarPrice: fieldProps.value,
        productType: 'gallery'
    }));
};
PriceField.displayName = 'PriceField';
export default PriceField;
